import { render, staticRenderFns } from "./tabPeringatan.vue?vue&type=template&id=11c7de0d"
import script from "./tabPeringatan.vue?vue&type=script&lang=js"
export * from "./tabPeringatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports